/**
 * @generated SignedSource<<523de6461c50f02240319678b7ba4c61>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4ProfileNew$data = {
  readonly me: {
    readonly user: {
      readonly email?: string | null | undefined;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly " $fragmentType": "Nav4ProfileNew";
};
export type Nav4ProfileNew$key = {
  readonly " $data"?: Nav4ProfileNew$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProfileNew">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4ProfileNew",
  "selections": [
    {
      "concreteType": "AuthenticationContext",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "picture"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "474a7ae4680da713d41fca308603671a";

export default node;
